export default "__VITE_ASSET__u5n9nWCC__"